<script lang="ts">
  import { MAX_FREE_MEMBERS } from "$app/constants"
  import SaveButton from "$app/Pages/Signup/SaveButton.svelte"
  import { catchError, toast, xhr } from "$app/utils"

  let saving = $state(false)
  let name = $state("")
  let errors: Record<string, any> = $state({})
  let skip_onboarding = $state(false)

  async function handleSubmit() {
    saving = true
    const [error, resp] = await catchError(
      xhr.post("/plans", {
        plan: { name: name },
        selected_plan_id: "free",
        subscription: {
          subscription_type: "free",
          billing_interval: "year",
          stripe_token: "st",
          full_access_total: MAX_FREE_MEMBERS
        },
        skip_onboarding: skip_onboarding
      })
    )
    if (error) {
      errors = error?.response?.data?.errors || {}
      saving = false
      let msg = "There are some errors. Please verify and try again."
      if (errors.name || errors.email || errors.password) {
        msg =
          "There are some errors on your account details. Please verify and try again"
      }
      toast(msg, "error", {
        duration: 15 * 60 * 1000
      })
      return
    }

    errors = {}
    saving = false
    if (resp.data?.redirection_path) {
      toast("Thank you for signing up!", "success")
      window.location.href = resp.data.redirection_path
    }
  }
</script>

<div class="px-4 py-2 space-y-8">
  <div class="mt-4 input-cont" class:error={errors.name}>
    <label for="company_name">Company Name</label>
    <input
      type="text"
      bind:value={name}
      class="input"
      id="company_name"
      placeholder="My Company INC."
    />
    <div class="msg">{errors.name}</div>
  </div>

  <div>
    <label for="skip_onboarding">
      <input
        type="checkbox"
        id="skip_onboarding"
        bind:checked={skip_onboarding}
      />
      Skip onboarding
    </label>
  </div>

  <SaveButton bind:saving onclick={handleSubmit} title="Create Free Plan" />
</div>
